import React from 'react'
import { ErroredInstance, LoadingInstance, isErrored, isLoading } from '@rwwa/rwwa-data-access'
import { List as ImmutableList } from 'immutable'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { MainContainer } from '@core/Components/Containers'
import { connect } from '@core/Components/HOCs/connect'
import { List, ListItem } from '@core/Components/List'
import { ErrorMessage, Message } from '@core/Components/Messages'
import { PoolKeys } from '@core/Data/Racing/pools'
import { useAppSeo } from '@core/Utils/hooks/useAppSeo'
import { Jackpot, JackpotLoading } from './Components/Jackpot'

export const Jackpots = () => {
  useAppSeo({
    title: 'Jackpots Promotions & Jackpots | TABtouch',
    description:
      'Explore jackpots, betting promotions and special offers available through TABtouch.',
  })

  return <ConnectedJackpots poolKeys='currentJackpotsByDate' />
}

const ConnectedJackpots = connect({ poolKeys: PoolKeys })(({ poolKeys }) => (
  <JackpotsComponent poolKeys={poolKeys} />
))

const JackpotsComponent: React.FC<{
  poolKeys: ImmutableList<string> | typeof LoadingInstance | typeof ErroredInstance
}> = ({ poolKeys }) => {
  const testId = { 'data-tid-jackpots-container': '' }
  return (
    <MainContainer {...testId}>
      <PageHeader title='Jackpots' />
      <JackpotsList poolKeys={poolKeys} />
    </MainContainer>
  )
}

const JackpotsList: React.FC<{
  poolKeys: ImmutableList<string> | typeof LoadingInstance | typeof ErroredInstance
}> = ({ poolKeys }) => {
  if (isLoading(poolKeys)) {
    return (
      <List data-testid='jackpotlist-loading'>
        <ListItem>
          <JackpotLoading />
        </ListItem>
      </List>
    )
  }

  if (isErrored(poolKeys)) {
    return <ErrorMessage>Error loading Jackpots</ErrorMessage>
  }

  if (!poolKeys.size) {
    return <Message>No Jackpots for today</Message>
  }

  return (
    <List>
      {poolKeys.toArray().map(poolKey => (
        <ListItem key={poolKey}>
          <Jackpot pool={poolKey} />
        </ListItem>
      ))}
    </List>
  )
}
